import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {ErrorView} from '../Shared/Constants';
import LightNotification from '../assets/lightNotification.svg';

const ErrorClientLocation = ({data, errorId}) => {
  const [tittleError, setTittleError] = useState(<div />);
  const [messageError, setMessageError] = useState(<div />);

  useEffect(() => {
    switch (errorId) {
      case ErrorView.Desktop:
        setTittleError(
          <div className='client-location__error-tittle' dangerouslySetInnerHTML={{__html: data?.errorTittleOnlyMobile?.value}} />
        );
        setMessageError(<div className='client-location__error-msg' dangerouslySetInnerHTML={{__html: data?.errorMsgOnlyMobile?.value}} />);
        break;
      default:
        break;
    }
  }, []);

  return (
    <div className='client-location__error'>
      <section className='client-location__error-img'>
        <Image src={LightNotification} alt='פעמון התראה' />
      </section>
      {tittleError}
      {messageError}
    </div>
  );
};

export default ErrorClientLocation;
